import store from '@/store'
import moment from 'moment/moment'

export function beforeEnter (to, from, next) {
  let promises = []
  promises.push(store.dispatch('dealers/get', {id: to.params.id}))
  promises.push(store.dispatch('periods/query', {sort: 'endDate desc', limit: 1000}).then(({data}) => {
    let currentPeriodId = null
    for (let period of data.items) {
      let today = moment()
      if (moment(period.startDate) <= today && moment(period.endDate) >= today) {
        store.dispatch('periods/current', period.id)
        currentPeriodId = period.id
      }
    }
    let periodPromises = []
    periodPromises.push(store.dispatch('branches/query', {'filters[where][dealerId][eq]': to.params.id, limit: 1000})
      .then(({data}) => {
        let branchIds = []
        for (let branch of data.items) {
          branchIds.push(branch.id)
        }
        return store.dispatch('branchScores/query', {
          'filters[where][periodId][eq]': currentPeriodId,
          'filters[whereIn][branchId]': branchIds
        })
      }))
    periodPromises.push(store.dispatch('dealerScores/query', {
      'filters[where][periodId][eq]': currentPeriodId,
      'filters[where][dealerId][eq]': to.params.id
    }))
    periodPromises.push(store.dispatch('dealerDivisionScores/query', {
      'filters[where][periodId][eq]': currentPeriodId,
      'filters[where][dealerId][eq]': to.params.id
    }))
    return Promise.all(periodPromises)
  }))
  next(Promise.all(promises))
}

export function beforeUpdate (to, from, next) {
  store.dispatch('dealers/query', to.query).then((response) => {
    next()
  }).catch(error => {
    next(error)
  })
}



// WEBPACK FOOTER //
// ./src/guards/dealers.guards.js